import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Inicio from "pages/Inicio";
import NotFound from "pages/NotFound";
import BasePage from "pages/BasePage";
import LerNoticia from 'components/Noticias/lerNoticia';
import PalavraDoPresidente from "pages/PalavraDoPresidente";
import Galeria from "pages/Galeria";
import Declaracoes from 'pages/Declaracoes';
import { trackPageView } from './analytcs';

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

function AppRoutes() {
  return (
    <BrowserRouter>
      <Analytics />
      <Routes>
        <Route path="/" element={<BasePage />}>
          <Route index element={<Inicio />}></Route>
          <Route path="*" element={<NotFound />}></Route>
          <Route path="/noticia/:noticiaId" element={<LerNoticia />} />
          <Route path="/palavra-do-presidente" element={<PalavraDoPresidente />}></Route>
          <Route path="/galeria" element={<Galeria />}></Route>
          <Route path="/declaracoes" element={<Declaracoes />} ></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
